// cookie初始化
import { initPageCommonHandle } from '@common-libs/tj-common-libs/page-handle'

initPageCommonHandle(()=>{})
